import React from "react";
import {DataTable, Modal, P} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../types/CustomerDTO";
import AppRolesService from "../../General/services/AppRolesService";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";

function WorkspaceDetails(props: { visible: boolean, selectedCustomer: CustomerDTO, handleClose: Function }) {
    
    const { accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const isAdmin = AppRolesService.isUserAdmin(accounts, isAuthenticated);
    
    const columns = React.useMemo(
        () => [
            { accessorKey: 'displayName', header: 'Property'},
            { accessorKey: 'value', header: 'Value'}
        ],
        [],
    );
    
    const data = [
        {
            key: 'organisationId',
            displayName: 'Organisation ID',
            value: props.selectedCustomer.accessOrganisationId
        },
        {
            key: 'public',
            displayName: 'Public Key',
            value: props.selectedCustomer.accessWorkspacePublicApiKey
        },
        ...(isAdmin ? [{
            key: 'private',
            displayName: 'Private Key',
            value: props.selectedCustomer.accessWorkspacePrivateApiKey
        }] : [])
    ];

    const renderModalContent = () => {
        return (
            <DataTable
                columns={columns}
                data={data}
                noDataElement={<P>Sorry, there is no Workspace Data available.</P>}
            />
        )
    }
    
    let content;
    content =
        <Modal
            visible={props.visible}
            accent='teal'
            heading={`Workspace Details`}
            primaryButtonProps={{buttonStyle: {'display': 'none'}}}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
        >
            <div style={{marginTop: '16px'}}>
                {renderModalContent()}
            </div>
        </Modal>

    return (
        <>
            {content}
        </>
    )

}

export default WorkspaceDetails;
